import type { PluginContainerData } from './../../ricos-schema/legacy/wix/rich_content/v1';

export const useCustomWidthStyle = ({
  containerData,
  isMobile,
  width,
}: {
  containerData: PluginContainerData;
  isMobile: boolean;
  width: number | undefined;
}) => {
  return containerData?.width?.size === 'ORIGINAL' ||
    (isMobile && (Number(containerData?.width?.custom) || 0) > 150)
    ? { width: width ?? 0 + 'px', maxWidth: '100%' }
    : {};
};
